import { ReactElement } from 'react';
import { PriceList as CorePriceList, Props } from '@client/product/components/ProductData/PriceList';
import classNames from 'classnames';
import './styles.scss';

export const PriceList = (props: Props): ReactElement => (
  <CorePriceList
    {...props}
    className={classNames(props.className, 'PriceList--BrackBusiness')}
  />
);
